import { useEffect, useState } from 'react'

const useTooltip = (): {
  setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>
  showTooltip: boolean
} => {
  const [showTooltip, setShowTooltip] = useState(false)
  useEffect(() => {
    let tooltipTimeout: ReturnType<typeof setTimeout>
    if (showTooltip) {
      tooltipTimeout = setTimeout(() => {
        setShowTooltip(false)
      }, 750)
    }

    return () => clearTimeout(tooltipTimeout)
  }, [showTooltip, setShowTooltip])

  return { setShowTooltip, showTooltip }
}

export default useTooltip
